import { createContext } from 'react';

import type { ModalProps } from './modal.types';

/**
 * Modal Context to pass "variant" and "onRequestClose" to the subcomponents
 * when necessary
 */
export const ModalContext = createContext<
  Required<Pick<ModalProps, 'variant' | 'onRequestClose'>>
>({
  onRequestClose: () => {
    return;
  },
  variant: 'standard',
});
